export const machineState = {
  // Abnormal Stop red
  1: "Aborting",
  2: "Clearing",
  3: "Aborted",

  // Controlled Stop red
  4: "Completed",
  5: "Stopped",
  6: "Stopping",
  7: "Resetting",

  // Ready to Start green
  8: "Idle",

  // Running green
  9: "Starting",
  10: "Execute",
  11: "Completing",

  // Material Exhausted (film) yellow
  12: "Holding",
  13: "Held (No Production)",
  14: "Unholding",

  // Starved Upstream or Blocked Downstream yellow
  15: "Suspending",
  16: "Suspended",
  17: "Unsuspending",

  // Additional Pal States blue
  18: "Pack Block",
  19: "Downstream",
  20: "Low Film",
  21: "Film Snap",
  22: "Reg Film Alarm",
  23: "Min Pack",
  24: "Max Pack",
  25: "Seal Over Value",
  26: "Seal Under Value",
};

export const machineStateColor = {
  red: [1, 2, 3, 4, 5, 6, 7],
  green: [8, 9, 10, 11],
  yellow: [12, 13, 14, 15, 16, 17],
  blue: [18, 19, 20, 21, 22, 23, 24, 25, 26],
};
